import React from 'react'

import userIconUrl from '@/assets/img/icons/user-outlines.svg'
import TabTitle from '@/components/misc/CompanyProfile/components/TabTitle'
import { Card, CardContent } from '@/components/ui/card'
import { THEME_PALETTE_LIGHT } from '@/lib/constants'
import { CompanyProfileItemFcaIndividual } from '@/types/responses/companies'

interface Props {
  fcaIndividuals: CompanyProfileItemFcaIndividual[]
}

const TeamTab: React.FC<Props> = ({ fcaIndividuals }) => (
  <>
    <TabTitle>FCA registered team members</TabTitle>

    <div className="flex flex-col gap-5">
      {fcaIndividuals.map((individual) => (
        <div key={individual.irn}>
          <Card
            className="py-2"
            style={{ borderColor: THEME_PALETTE_LIGHT.grayLight }}
          >
            <CardContent>
              <div
                className="mb-4 flex size-16 items-center justify-center
                  rounded-full bg-gray-200"
              >
                <img src={userIconUrl} alt="person profile icon" />
              </div>

              <p className="mb-1 font-medium" style={{ color: 'black' }}>
                {individual.name}
              </p>

              <p className="mb-1" style={{ minHeight: '50px' }}>
                Specialist qualifications:{' '}
                {individual.qualifications.length > 0 && (
                  <>{individual.qualifications.join(' • ')}</>
                )}
                {individual.qualifications.length === 0 && <>N/A</>}
              </p>

              <p className="mt-auto mb-4">
                FCA number:{' '}
                <a
                  href={
                    'https://register.fca.org.uk/s/individual?id=' +
                    individual.id
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  {individual.irn}
                </a>
              </p>
            </CardContent>
          </Card>
        </div>
      ))}
    </div>
  </>
)

export default TeamTab
